export default "__VITE_ASSET__b2ded5ba__"